import { useState } from "react";
import { MazeGame } from "./components/MazeGame";
import { signInWithGoogle, testAdminUpload } from "./services/storageTest";
import { HouseAdLocalPreview, LOCAL_PREVIEW_CAMPAIGNS } from "./components/HouseAdLocalPreview";
import { HouseAdGameTest } from "./components/HouseAdGameTest";

function App() {
  const [status, setStatus] = useState<string>("");

  const handleSignIn = async () => {
    try {
      setStatus("Signing in...");
      const user = await signInWithGoogle();
      setStatus(`Signed in as: ${user?.email} (${user?.uid})`);
    } catch (err: any) {
      setStatus(`Sign-in Error: ${err.message}`);
    }
  };

  const handleUpload = async () => {
    try {
      setStatus("Uploading...");
      await testAdminUpload();
      setStatus("✅ Upload successful! Check Storage > Files > public/admin-test.txt");
    } catch (err: any) {
      setStatus(`❌ Upload failed: ${err.message}`);
    }
  };

  const localHouseAdPreviewId = import.meta.env.DEV
    ? new URLSearchParams(window.location.search).get('houseAdPreview')
    : null;
  const showLocalHouseAdPreview = localHouseAdPreviewId && LOCAL_PREVIEW_CAMPAIGNS[localHouseAdPreviewId];
  const localHouseAdTestId = import.meta.env.DEV
    ? new URLSearchParams(window.location.search).get('houseAdTest')
    : null;
  const showLocalHouseAdTest = localHouseAdTestId && LOCAL_PREVIEW_CAMPAIGNS[localHouseAdTestId];
  const localPreviewMedia = new URLSearchParams(window.location.search).get('houseAdMedia') === 'video' ? 'video' : 'still';

  if (showLocalHouseAdPreview) return <HouseAdLocalPreview campaignId={localHouseAdPreviewId} media={localPreviewMedia} />;
  if (showLocalHouseAdTest) return <HouseAdGameTest campaignId={localHouseAdTestId} />;

  return (
    <>
      {/* Admin Panel removed for production */}
      <MazeGame />
    </>
  );
}

export default App;
